module.exports = __webpack_public_path__ + "img/calib.8751d419.svg";